import { useEffect } from 'react'
import { useParams } from 'react-router'
import Wrapper from 'components/reusables/wrapper'
import { rolesService } from 'api/configuration/roles'
import { useRolesAndPermissions } from '../../context/RolesAndPermissionsContext'
import AccessToLearningPrograms from './accessToLearningPrograms'
import Header from './header'
import Buttons from './buttons'
import Inputs from './inputs'
import Accesses from './accesses'
import AccessToCourses from './accessToCourses'

const RoleForm = () => {
  const { setRoleDetail, resetRoleDetail } = useRolesAndPermissions()
  const { id: roleId } = useParams<{ id: string }>()
  const isEditing = Boolean(roleId)

  useEffect(() => {
    if (isEditing) {
      getRoleDetail()
    } else {
      resetRoleDetail()
    }
  }, [isEditing, resetRoleDetail, roleId])

  const getRoleDetail = () => {
    rolesService.getRoleDetail(roleId).then((response) => {
      setRoleDetail(response.data)
    })
  }

  return (
    <Wrapper shadow={true}>
      <Header />
      <Inputs />
      <AccessToLearningPrograms />
      <AccessToCourses />
      <Accesses />
      <Buttons />
    </Wrapper>
  )
}

export default RoleForm
